import { apiGet, apiSend, apiUpload } from "./api";
import { Article, ArticleFormValues, ArticleListItem } from "./types";

export async function listArticles(): Promise<ArticleListItem[]> {
  const data = await apiGet("/admin/articles");
  return data.articles as ArticleListItem[];
}

export async function getArticle(id: string): Promise<Article> {
  const data = await apiGet(`/admin/articles/${id}`);
  return data.article as Article;
}

export async function createArticle(
  slug: string,
  values: ArticleFormValues,
): Promise<Article> {
  const data = await apiSend("POST", "/admin/articles", { slug, ...values });
  return data.article as Article;
}

export async function updateArticle(
  id: string,
  values: Partial<ArticleFormValues> & { slug?: string },
): Promise<Article> {
  const data = await apiSend("PUT", `/admin/articles/${id}`, values);
  return data.article as Article;
}

export async function deleteArticle(id: string): Promise<void> {
  await apiSend("DELETE", `/admin/articles/${id}`);
}

export async function uploadArticleCoverImage(id: string, file: File): Promise<Article> {
  const formData = new FormData();
  formData.append("file", file);
  const data = await apiUpload(`/admin/articles/${id}/cover-image`, formData);
  return data.article as Article;
}

export async function deleteArticleCoverImage(id: string): Promise<Article> {
  const data = await apiSend("DELETE", `/admin/articles/${id}/cover-image`);
  return data.article as Article;
}
